module.exports = __webpack_public_path__ + "static/category-jeans-b6f1125894e98a873e3dfcfb7c14a865.jpg";